import { FlexContainer } from './styles';
import { BookingPanel } from './bookingPanel';
import { ResourcesPanel } from 'features/booking/resourcesPanel';
import {
	getPersonsBookList,
	PersonBook,
	selectPerson,
	usePerson,
} from 'entities/person';
import { PaginationFilterPersonsProvider } from 'shared/ui/pagination';
import { HallmapManager } from 'features/hallmapManager';
import { FC, Fragment } from 'react';
import { BookingProps } from '../types';
import { ModalProvider } from 'shared/ui/modal';
import { PersonModalCard } from 'widgets/personModalCard';
import { useAppSelector } from 'shared/lib/store';
import { selectBookingApplicationMod } from 'entities/orders';

export const BookingSystem: FC<BookingProps> = props => {
	const { isOpenPersonBook, setPerson, setOpenPersonBook } = usePerson();
	const selectedPerson = useAppSelector(selectPerson);
	const appMod = useAppSelector(selectBookingApplicationMod);

	const selectPersonAndBook = () => {
		if (!appMod) {
			setOpenPersonBook(false);
		}
		setPerson(selectedPerson);
	};

	return (
		<Fragment>
			<PaginationFilterPersonsProvider fetchData={getPersonsBookList}>
				<ModalProvider>
					<PersonBook />
					<PersonModalCard
						onBooking={selectPersonAndBook}
						showOrderEdit={false}
						updatePersonBook={true}
					/>
				</ModalProvider>
				<FlexContainer $show={!isOpenPersonBook}>
					<ResourcesPanel />
					<HallmapManager
						hallmapId="hallmap-modal"
						hallmapContainerId="hallmap-modal-container"
						mode="select"
					/>
				</FlexContainer>
				<BookingPanel {...props} />
			</PaginationFilterPersonsProvider>
		</Fragment>
	);
};
